
(() => {
  const FEE_VARIANT_ID = 54630949585243;
  const CHILLED_COLLECTION = 'chilled-products';
  const FEE_MARKER = '_chilled_packaging_fee';
  let updating = false;

  async function getJSON(url, options) {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error(`Shopify error: ${response.status}`);
    return response.json();
  }

  async function syncChilledFee() {
    if (updating) return;
    updating = true;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const cart = await getJSON(root + 'cart.js');

      const feeItems = cart.items.filter(
        item => item.variant_id === FEE_VARIANT_ID
      );

      // Check the actual products against the chilled collection.
      const chilledCollection = await getJSON(
        root + 'collections/' + CHILLED_COLLECTION + '/products.json?limit=250'
      );

      const chilledProductIds = new Set(
        chilledCollection.products.map(product => product.id)
      );

      const hasChilled = cart.items.some(item =>
        item.variant_id !== FEE_VARIANT_ID &&
        chilledProductIds.has(item.product_id)
      );

      const managedFees = feeItems.filter(
        item => item.properties?.[FEE_MARKER] === 'yes'
      );

      if (hasChilled && feeItems.length === 0) {
        await getJSON(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: FEE_VARIANT_ID,
              quantity: 1,
              properties: { [FEE_MARKER]: 'yes' }
            }]
          })
        });

        window.location.reload();
      } else if (!hasChilled && managedFees.length) {
        for (const fee of managedFees) {
          await getJSON(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: fee.key,
              quantity: 0
            })
          });
        }

        window.location.reload();
      } else if (managedFees.length === 1 &&
                 managedFees[0].quantity !== 1) {
        await getJSON(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: managedFees[0].key,
            quantity: 1
          })
        });

        window.location.reload();
      }
    } catch (error) {
      console.error('Chilled packaging fee:', error);
    } finally {
      updating = false;
    }
  }

  document.addEventListener('DOMContentLoaded', syncChilledFee);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) syncChilledFee();
  });

  // Recheck after Shopify's AJAX cart requests.
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = String(args[0]?.url || args[0] || '');

    if (/\/cart\/(add|change|update|clear)\.js/.test(url)) {
      setTimeout(syncChilledFee, 200);
    }

    return response;
  };
})();
